import MiniAppContainer from "./MiniAppContainer";
import MiniAppHeader from "./layout/MiniAppHeader";
import { useSelector } from "react-redux";
import { useState } from "react";
import styles from "../../styles/Components/mini-app/mini-bots/MiniBotsPool.module.css";
import { Skeleton } from "antd";
import EmptyBox from "../../ui/EmptyBox";
import CommunityBotItem from "../new-dashboard/top-community-bot/CommunityBotItem";
import useFetchDashboardBotPerformance from "../../hooks/api/useFetchDashboardBotPerformance";

function MiniBotsPool() {
  const {
    dashboard: { botInfoStatus, communityBots },
  } = useSelector((state) => state);

  const [activeTab, setActiveTab] = useState("short");

  const {
    one_month: bots1st = [],
    two_months: bots2nd = [],
    three_months: bots3nd = [],
  } = communityBots;

  const bots =
    activeTab === "short" ? bots1st : bots2nd?.length > 0 ? bots2nd : bots3nd;
  const profitDivisionFactor =
    activeTab === "short" ? 1 : bots2nd?.length > 0 ? 2 : 3;

  useFetchDashboardBotPerformance();

  return (
    <MiniAppContainer>
      <MiniAppHeader page="Bots Pool" />
      <div className={styles.tabs}>
        <span
          className={`${styles.tabItem} ${activeTab === "short" ? styles.activeTab : ""}`}
          onClick={() => setActiveTab("short")}
        >
          Short term
        </span>
        <span
          className={`${styles.tabItem} ${activeTab === "long" ? styles.activeTab : ""}`}
          onClick={() => setActiveTab("long")}
        >
          Long term
        </span>
      </div>

      <div className={styles.botList}>
        {botInfoStatus === "loading" ? (
          Array.from({ length: 3 }).map((_, i) => (
            <Skeleton.Node key={i} active className={styles.loader} />
          ))
        ) : bots?.length === 0 ? (
          <div className={styles.emptyMessage}>
            <EmptyBox useCase="table" size={50} color="#B0B0B0" />
            Not available data for now.
          </div>
        ) : (
          bots.map((bot, i) => (
            <CommunityBotItem
              key={i}
              data={bot}
              divisionFactor={profitDivisionFactor}
            />
          ))
        )}
      </div>
    </MiniAppContainer>
  );
}

export default MiniBotsPool;
